const BOSS_MENU_PERMISSIONS_LIST = [
  {
    code: 'SETTINGS_PERMISSIONS',
    linkData: {
      path: 'statistic/object',
      title: 'Obyekt',
    },
    iconName: 'bi bi-house',
    order: 1,
  },
  {
    code: 'SETTINGS_PERMISSIONS',
    linkData: {
      path: 'statistic/account',
      title: 'Kassalar',
    },
    iconName: 'bi bi-cash-coin',
    order: 2,
  },
  {
    code: 'SETTINGS_PERMISSIONS',
    linkData: {
      path: 'statistic/warehouse',
      title: 'Omborlar',
    },
    iconName: 'bi bi-shop-window',
    order: 3,
  },
  {
    code: 'SETTINGS_PERMISSIONS',
    linkData: {
      path: 'statistic/expense',
      title: 'Xarajatlar',
    },
    iconName: 'bi bi-airplane',
    order: 4,
  },
  {
    code: 'SETTINGS_PERMISSIONS',
    linkData: {
      path: 'statistic/income-outcomes',
      title: 'Kirim-chiqimlar',
    },
    iconName: 'bi bi-arrow-down-up',
    order: 5,
  },
];

export default BOSS_MENU_PERMISSIONS_LIST;
